export default __webpack_public_path__ + "static/media/dashboard-active.0bd6e03f.svg";